










































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IProposalCreateRequest, IProposalRequest } from "@/types/proposal";
import { IProposal, IProposalUpdateRequest } from "@/types/proposal";
import { ISelectItem } from "@/types";
import { ProposalRequest, ProposalUpdateRequest } from "@/models/proposal";
import {
  IPartner,
  IPartnerCreateRequest,
  IPartnerListRequest,
} from "@/types/partner";
import { IChannelListRequest } from "@/types/channel";
import { PartnerCreateRequest } from "@/models/partner";
import { IMemberListRequest } from "@/types/member";
import { ISkillListRequest } from "@/types/skill";

@Component({})
export default class extends Vue {
  date(date: any) {
    throw new Error("Method not implemented.");
  }
  @Action("proposal/salesGet")
  public getProposal!: (id: number) => Promise<void>;

  @Getter("proposal/single")
  public proposal!: IProposal;

  @Action("proposal/salesCreate")
  public create!: (params: IProposalCreateRequest) => Promise<boolean>;

  @Action("proposal/salesUpdate")
  public update!: (data: {
    proposal_id: number;
    params: IProposalUpdateRequest;
  }) => boolean;

  @Mutation("proposal/clear")
  public clear!: () => void;

  @Action("partner/salesGetList")
  public getPartnerList!: (params: IPartnerListRequest) => Promise<void>;

  @Action("partner/salesCreate")
  public createPartner!: (params: IPartnerCreateRequest) => Promise<boolean>;

  @Getter("partner/selectItem")
  public partnerList!: ISelectItem[];

  @Getter("partner/single")
  public partner!: IPartner;

  @Action("channel/getList")
  public getChannelList!: (params: IChannelListRequest) => Promise<void>;

  @Getter("channel/selectItem")
  public channelList!: ISelectItem[];

  @Action("member/adminGetList")
  public getMemberList!: (params: IMemberListRequest) => Promise<void>;

  @Getter("member/selectItem")
  public memberList!: ISelectItem[];

  @Action("skill/getList")
  public getSkillList!: (params: ISkillListRequest) => Promise<void>;

  @Getter("skill/selectItem")
  public skillList!: ISelectItem[];

  @Getter("error/error")
  public getError!: (key: string) => string[];

  @Getter("error/errors")
  public getErrors!: () => string[];

  public proposal_id = 0;
  public member_id = 0;
  public dialog = false;
  public start_open = false;
  public end_open = false;

  public params: IProposalRequest = new ProposalRequest();
  public partnerParams: IPartnerCreateRequest = new PartnerCreateRequest();

  private async created() {
    this.clear();

    this.proposal_id = Number(this.$route.params.proposal_id);
    this.member_id = Number(this.$route.params.member_id);
    if (this.proposal_id) {
      await this.getProposal(this.proposal_id);
      this.params = new ProposalUpdateRequest(this.proposal);
    } else if (this.member_id) {
      this.params.members.push(this.member_id);
    }

    await Promise.all([
      this.getChannelList({ per_page: 0 }),
      this.getPartnerList({ per_page: 0 }),
      this.getMemberList({ per_page: 0 }),
      this.getSkillList({ per_page: 0 }),
    ]);
  }

  public async partnerInsert() {
    await this.createPartner(this.partnerParams);
    await this.getPartnerList({ per_page: 0 });
    this.params.partner_id = this.partner.id;
    this.dialog = false;
  }

  public async submit() {
    let result = false;

    if (this.proposal_id) {
      result = await this.update({
        proposal_id: this.proposal.id,
        params: this.params,
      });
    } else {
      result = await this.create(this.params);
    }

    if (result) {
      this.$router.go(-1);
    }
  }

  public get rules() {
    return {
      title: [
        (v: string) => !!v || "案件タイトルは必須です",
        (v: string) => v.length <= 255 || "255文字以内で入力してください",
      ],
      span_start: [],
      span_end: [
        (v: string) =>
          !v ||
          !this.params.span_start ||
          v > this.params.span_start ||
          "終了日は開始日より未来にしてください",
      ],
      reward_upper: [
        (v: number) =>
          !v ||
          typeof v === "number" ||
          0 <= v ||
          "０以上の数字を入れてください",
        (v: number) =>
          !v ||
          !this.params.reward_lower ||
          v >= this.params.reward_lower ||
          "下限以上の値にしてください",
      ],
      reward_lower: [
        (v: number) =>
          !v ||
          typeof v === "number" ||
          0 <= v ||
          "０以上の数字を入れてください",
      ],
      summary: [(v: string) => !!v || "内容は必須です"],
      channel_id: [(v: string) => !!v || "チャネルは必須です"],
      partner_id: [(v: string) => !!v || "顧客は必須です"],
    };
  }
}
